var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('themed-card',{attrs:{"outlined":"","width":"100%","height":"100%"}},[_c('v-card-title',[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_c('v-card-text',{staticClass:"text--primary"},_vm._l((_vm.fields),function(field,index){return _c('field',{key:index,attrs:{"field":field,"index":index}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }